import React from 'react';

import Text from './Text';
import Accordion from './Accordion';

const TextAccordion = ({ title = '', content = '' }) => {
  return (
    <Accordion title={title}>
      <Text textStyle="small" style={{ color: 'greyOther' }} asHtml>{content}</Text>
    </Accordion>
  );
};

export default TextAccordion;
